import { render, staticRenderFns } from "./PleaseWait.vue?vue&type=template&id=31bb3b9e&scoped=true&"
import script from "./PleaseWait.vue?vue&type=script&lang=js&"
export * from "./PleaseWait.vue?vue&type=script&lang=js&"
import style0 from "./PleaseWait.vue?vue&type=style&index=0&id=31bb3b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bb3b9e",
  null
  
)

export default component.exports